import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage({ onLoginSuccess }) {
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({
    username: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      // Assuming apiClient is globally available or imported
      const response = await fetch('/api/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: loginData.username,
          password: loginData.password
        })
      });
      const data = await response.json();
      // const userrole = data.users?.[0]?.username || '';
      // localStorage.setItem('userrole', userrole);

      if (data.success) {
                // Store token in localStorage for API requests
        if (data.token) {
          localStorage.setItem('token', data.token);
        }
        // Store user info
        localStorage.setItem('userrole', data.user.role || '');
        localStorage.setItem('firstName', data.user.firstName || '');
        localStorage.setItem('user', JSON.stringify(data.user));

        setMessage('Login successful!');
        onLoginSuccess();
        navigate('/dashboard');
      } else {
        setMessage(data.error || 'Login failed');
      }
    } catch (error) {
      setMessage('Login failed - Check console');
      console.error('Login error details:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src="/logo.png" alt="logo" className="login-logo" />
        <h1>Customer Relationship Management</h1>
        <div className="login-form-group">
          <label>Username:</label>
          <input
            type="text"
            name="username"
            value={loginData.username}
            onChange={handleLoginChange}
          />
        </div>
        <div className="login-form-group">
          <label>Password:</label>
          <input
            type="password"
            name="password"
            value={loginData.password}
            onChange={handleLoginChange}
          />
        </div>
        <button className='btn login' onClick={handleLogin} disabled={isLoading}>
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
}

export default LoginPage;
